import { WasmLoader } from '@seddi/core';
import WaAvatars from '@seddi/wa-avatars';
import wasmAvatarsUrl from '@seddi/wa-avatars/lib/index.wasm';
import log from 'loglevel';
import {
  type AxiosProgressHandler,
  fetch as fetchCache,
  deleteUnknown,
  open as openCache,
  isSupported as isSupportedCache,
} from './cache';

const WA_AVATARS_FS_VERSION = 'v1';
const WA_AVATARS_FS_KEY = `wa-avatars-fs-${WA_AVATARS_FS_VERSION}`;

/**
 * Initialize lib.
 * @param onDownloadProgress - the download progress handler.
 */
export async function initializeLib(
  filesystemUrl: string,
  onDownloadProgress?: AxiosProgressHandler,
): Promise<void> {
  // NOTE: Move down if caches start to be used in other contexts
  isSupportedCache();
  void deleteUnknown([WA_AVATARS_FS_KEY]);

  try {
    // Fetch wa-avatars filesystem through cache
    const cache = await openCache(WA_AVATARS_FS_KEY);

    const wasmAvatarsFs = await fetchCache(cache, filesystemUrl, onDownloadProgress).then(
      response => response.arrayBuffer(),
    );

    // fetch wasm modules
    const [wasmAvatarsBuf] = await Promise.all([
      fetch(wasmAvatarsUrl).then(res => res.arrayBuffer()),
    ]);
    const wasmAvatars = new Uint8Array(wasmAvatarsBuf);

    // init wasm modules
    await Promise.all([
      WasmLoader.Load(WaAvatars, wasmAvatars, {
        getPreloadedPackage: () => wasmAvatarsFs,
      }),
    ]);

    log.debug('Load ui-babylon-smpl done');
  } catch (e) {
    log.error('Load ui-babylon-smpl failed', e);
  }
}
